import React, { Fragment, Component } from 'react'
import { ChromePicker } from 'react-color'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { hasGates } from 'utils/access'

import { getColor } from 'modules/settings/selectors'
import { setColor } from 'modules/settings/actions'

import cx from 'classnames'
import arrowSrc from 'images/arrow.svg'

import './style.css'

class ColorPicker extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showPicker: false,
      currentColor: props.color
    }
  }
  
  static getDerivedStateFromProps(nextProps) {
    return {
      currentColor: nextProps.color
    }
  }
  
  handleClick = () =>
    this.setState(prevState => ({
      showPicker: !prevState.showPicker
    }))
  
  handleChangeComplete = color =>
    this.props.setColor(color.hex)
  
  handleChange = color =>
    this.setState({
      currentColor: color.hex
    })
  
  render() {
    const { showPicker } = this.state
    
    return (
      <div className={cx({
        container: hasGates('has_new_dh_settings')
      })}>
        <div className="color-picker-wrapper">
          <div onClick={this.handleClick} className="color-picker-dropdown">
            <div
              style={{
                backgroundColor: this.state.currentColor
              }}
             className="color-picker-current-color"
            >&nbsp;</div>
            <span className="color-picker-color-hex">{`${this.state.currentColor.toUpperCase()}`}</span>
            <img
              alt="arrow"
              src={arrowSrc}
              className={cx('color-picker-dropdown-arrow', {
                'color-picker-show-open-arrow': showPicker
              })}
            />
          </div>
          {showPicker &&
            <div className="color-picker-popover">
              <div className="color-picker-cover" onClick={this.handleClick}/>
              <ChromePicker
                color={ this.state.currentColor }
                onChange={this.handleChange}
                onChangeComplete={this.handleChangeComplete}
                disableAlpha
              />
            </div>
          }
        </div>
        <div className="color-picker-description">
          <Fragment>
            <p className="color-picker-description-text">This color will be used as the background for the header of your help center.</p>
          </Fragment>
        </div>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  color: getColor(state)
})

const mapDispatchToProps = dispatch => bindActionCreators({
  setColor
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ColorPicker)
